<template>
  <div class="coupon-center-page">
    <van-empty v-if="couponList.length <= 0" description="暂无数据~" />
    <van-list
      v-else
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="list"
        :class="{
          blbg: true,
        }"
        v-for="(item, index) in couponList"
        :key="index"
      >
        <div class="left">
          <div class="coupon-title">{{ item.name }}</div>
          <div class="coupon-time" v-if="item.validStartTime">
            {{ showDate(item.validStartTime) }}至{{
              showDate(item.validEndTime)
            }}
          </div>
          <div class="coupon-type">{{ item.instructions }}</div>
        </div>
        <div class="right">
          <div class="coupon-price">￥{{ item.kimsPrice }}</div>
          <div class="coupon-price1 van-ellipsis">
            满{{ item.useConditions }}可用
          </div>
          <div
            class="btn"
            @click="goPay(item)"
            :class="{ 'active-btn': item.receiveStatus === '1' }"
          >
            {{ item.receiveStatus === "1" ? "领取" : "已领取" }}
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getImgUrl } from "@/mixins/getImgUrl";
import { parseTime } from "@/utils";
import { Notify } from "vant";

export default {
  mixins: [getImgUrl],
  data() {
    return {
      loading: false,
      finished: false,
      couponList: [],
      page: {
        pageNum: 0,
        pageSize: 20,
      },
    };
  },
  computed: {
    showDate() {
      return function(date) {
        if (date) {
          return parseTime(date, "{yyyy}-{mm}-{dd}");
        }
        return "";
      };
    },
    showBtnStr() {
      var that = this;
      return function(item) {
        return "已使用";
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.page.pageNum++;
      this.loading = true;
      this.requestCouponList();
    },
    requestCouponList() {
      var param = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      var data = {
        receiveChannel: "h5",
      };
      this.$API.coupons
        .couponCenter(param, data)
        .then((res) => {
          if (this.page.pageNum === 1) {
            this.couponList = res.rows;
          } else {
            this.couponList = [...this.couponList, ...res.rows];
          }

          this.loading = false;
          this.finished = this.couponList.length >= parseInt(res.total);
        })
        .catch((err) => {});
    },
    // 领取消费劵
    goPay(item) {
      if (item.receiveStatus === "1") {
        const user = this.$store.state.userInfo_v2.user;
        var param = {
          id: item.id,
          userName: user.userName || "",
          userId: user.userId || "",
          receiveChannel: "h5",
        };
        this.$API.coupons
          .acquireActivityCoupons(param)
          .then((res) => {
            item.receiveStatus = "0";
            Notify({ type: "success", message: res.msg });
          })
          .catch((err) => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-center-page {
  background-color: white;
  .list {
    box-sizing: border-box;
    width: vw(690);
    height: vw(200);
    display: flex;
    margin: vw(30) auto 0;
    padding: vw(20);
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .left {
      flex: 1;
      .coupon-title {
        height: vw(45);
        line-height: vw(45);
        font-size: vw(32);
      }
      .coupon-time {
        font-size: vw(26);
      }
      .coupon-type {
        font-size: vw(26);
      }
    }
    .right {
      width: 30%;
      align-items: center;
      .coupon-price {
        height: vw(59);
        font-size: vw(42);
        color: #ff5232;
      }
      .coupon-price1 {
        font-size: vw(24);
      }
    }
  }
  .blbg {
    background-image: url("../../assets/market/coupons-bg02.png");
    background-position: top left;
    background-repeat: no-repeat;
    background-size: vw(690) vw(200);
    color: #b6cfff;
    .left .coupon-title {
      color: #3377ff;
    }
    .right .coupon-price,
    .coupon-price1 {
      color: #3377ff;
    }

    .btn {
      width: vw(118);
      height: vw(48);
      text-align: center;
      line-height: vw(48);
      border-radius: vw(24);
      border: 1px solid #999;
      color: #999;
      font-size: vw(24);
    }
    .active-btn {
      border: 1px solid #3377ff;
      color: #3377ff;
    }
  }
}
</style>
